import request from '@/utils/request'

export function getSaaSproviders() {
  return request({
    url: '/ajax/saas/providers',
    method: 'get'
  })
}



export function getAppDetailInfo(eid, appKeyID, appVersion) {
  return request({
    url: '/ajax/enterprises/' + eid + '/apps/' + appKeyID + '?version=' + appVersion,
    method: 'get'
  })
}

export function getAppPriceInfo(eid, appKeyID, appVersion) {
  return request({
    url: '/ajax/enterprises/' + eid + '/apps/' + appKeyID + '/priceinfo?version=' + appVersion,
    method: 'get'
  })
}

export function createOrder(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/orders',
    method: 'post',
    data: {
      'eid': data.eid,
      'app_key_id': data.app_key_id,
      'app_version': data.app_version,
      'app_fee': data.app_fee,
      'app_cycle': data.app_cycle,
      'svc_provider_id': data.svc_provider_id,
      'svc_fee': data.svc_fee,
      'svc_cycle': data.svc_cycle,
      'delivery_mode': data.delivery_mode,
      'ptype': data.ptype,
      'final_fee': data.final_fee,
      'note': data.note
    }
  })

}

export function orderPayment(data) {
  return request({
    url: '/ajax/enterprises/' + data.eid + '/orders/' + data.orderID + '/pay',
    method: 'post',
    data: {
      'pay_type': 'integral'
    }
  })
}

export function getOrderByID(eid, orderID) {
  return request({
    url: '/ajax/enterprises/' + eid + '/orders/' + orderID,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/payment.js